import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x107a441C473517a37b03dcd8024C5B63E3Cc13DF"),
    {
      name: "MEV Capital wBNB",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x7593931d08e3BAA750cA3cB6A0d0fDe6acD65107"),
    {
      name: "MEV Capital slisBNB",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x216f6D6C2ca15f83B656f3E9a8FcDf615DBC1710"),
    {
      name: "MEV Capital ETH",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0xe54DFfd36177975938A3873e522dEE535ADebe01"),
    {
      name: "MEV Capital USDT",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x0dD93eb321A768A274d21062067B52527aBd4506"),
    {
      name: "MEV Capital lisUSD",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0xD98125a23fAeb48180e33cA6Eef8F128E07418d1"),
    {
      name: "MEV Capital USDC",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x777C95b204E2Ed3906885eF09f4531882587B52C"),
    {
      name: "MEV Capital BTCB",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0xd6F4Ee21c946071Cf13D773E2ab1e31d44a27a54"),
    {
      name: "MEV Capital USDe",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0x088241d1C5c951C59Fb66083b291b69E3cC27E8C"),
    {
      name: "MEV Capital sUSDe",
      description: "Component of the MEV Capital BNB Cluster",
      entity: "mev-capital",
    },
  ],
  [
    getAddress("0xC6767dd1fFaA730f6fc90b353d5928E6e9d55C1b"),
    {
      name: "Apostro BSC BNB",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0xa6282FfCDBC1d23dDAd65e97B9d033C4517Ec05E"),
    {
      name: "Apostro BSC ETH",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x6078b5dE9d10587cb466ECbBF55C95898AFe99C2"),
    {
      name: "Apostro BSC USDT",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0xc27d44A8aEA0CDa482600136c0d0876e807f6C1a"),
    {
      name: "Apostro BSC USDC",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0xC0C13008711cE250699E3A94dCEED5EFd4e8e02a"),
    {
      name: "Apostro BSC BTCB",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x36AEb594689205878E1B57bFc011e0956D82ed08"),
    {
      name: "Apostro BSC PT-sUSDE-26JUN2025",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x9AE0Da6ACc874119470b52f4f5647B74D042b18B"),
    {
      name: "Apostro BSC sUSDe",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0xeEC4561f621C3629F2b36a07B207A7E06377e0D5"),
    {
      name: "Apostro BSC USDe",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x19C1d7E5a2b821D4e05fd9cFB8ba372C2cAA551B"),
    {
      name: "Apostro BSC lisUSD",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x3135551ce7945c03C18df7985E089DDBC763cEE8"),
    {
      name: "Apostro BSC USR",
      description: "Part of Apostro BSC market",
      entity: "apostro",
    },
  ],
  [
    getAddress("0x5fd02479F938929F6b9fE1b7Af6430cfD4afa6Aa"),
    {
      name: "Tulipa BNB USDT",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xA9cA5c4bfF689afcFB249AE81565422fa78F82b4"),
    {
      name: "Tulipa BNB USDC",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xEcD1F58B9DC4bbC3A32409961B8520B0A8fcd483"),
    {
      name: "Tulipa BNB USDE",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0x932FE4797d681a7a82262BC385B534ba069249E1"),
    {
      name: "Tulipa BNB SUSDE",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xa6439FD63C19Cc4893EAcaD20320D11cfd0Ad12C"),
    {
      name: "Tulipa BNB WBNB",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xfd30377A3173f709d8224Fee7718E312A0868A34"),
    {
      name: "Tulipa BNB BTCB",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xc33c2A5f3c27bcB5559f17ff97A04F281f898f04"),
    {
      name: "Tulipa BNB ETH",
      description: "Component of the Tulipa BNB market",
      entity: "tulipa-capital",
    },
  ],
  [
    getAddress("0xca522ECab584b5430ADb946edEE4224A63628362"),
    {
      name: "K3 Capital USDT",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x8CE379f1e092f0afCef665529F0d86acf92E8Cd4"),
    {
      name: "K3 Capital USDC",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x1E55a40c9C7ca76a8671D8366bEC8c5f8754a336"),
    {
      name: "K3 Capital sUSDe",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x07167e620612069830fdB5289406bB7A1Ddf781c"),
    {
      name: "K3 Capital USDe",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x88A81184243c561026973d25384651E6cc0796A4"),
    {
      name: "K3 Capital USR",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x10888BD509aC3e1f423D171008288462988827d5"),
    {
      name: "K3 Capital YUSD",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x9D30f4226D9aBE940F05acAfD456153BD49ba6D9"),
    {
      name: "K3 Capital PT-sUSDE-26JUN2025",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x470379C4416300068E9Afb938b7A0cfF7735d42f"),
    {
      name: "K3 Capital USD1",
      description: "Component of the K3 Capital Stablecoin Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x8E01DB38a409D6E6B8A81fd21d84E05912e8730A"),
    {
      name: "K3 Capital WBNB",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x554a419891bD825e47bC132011821dE1070c35C0"),
    {
      name: "K3 Capital BTCB",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0xA3031755F95E57E1AC9Bb01dBfEb135d40b6DA96"),
    {
      name: "K3 Capital slisBNB",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x78F5d9909163695dfB064d55A222E398918e00a3"),
    {
      name: "K3 Capital ynBNBx",
      description: "Component of the K3 Capital Cluster",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x7a455f66FD2D2d5C69ae403a971ED513C852F9D7"),
    {
      name: "Re7 Labs BTCB",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x266D3F3219680624DE4D66c716444512A2B9a72F"),
    {
      name: "Re7 Labs lisUSD",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xa0b6d76452B1f417a94Ae309b835D523a081FbB9"),
    {
      name: "Re7 Labs ETH",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xF72aB1726e6f379891dDAE8114C75074d972FdAc"),
    {
      name: "Re7 Labs slisBNB",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x3ac88AfbC38Bb41443457eeB027b60e85B815538"),
    {
      name: "Re7 Labs WBNB",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x69A93DbAB609266af96f05658b2e22d020de2E19"),
    {
      name: "Re7 Labs USDT",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xfEb1D6259De6C052A0d0f986b4Df4D8Fd8B371F4"),
    {
      name: "Re7 Labs solvBTC",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xCB9c9FE7d1509955d8b860E6831d91bf3F0B6240"),
    {
      name: "Re7 Labs USDC",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xcCD520c8cE2aC576429bE0aD8cc14cDc0e3E44fc"),
    {
      name: "Re7 Labs WBTC",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xc4dB46B082B415c16C54c91c5750Df8e2f90EF36"),
    {
      name: "Re7 Labs yUSD",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xC41f2Ba7102e9F9F2d603eb951F955aE205ed272"),
    {
      name: "Re7 Labs USD1",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x5d3b4bcff6a24A20a98070263D03D474586c9b29"),
    {
      name: "Re7 Labs USDX",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0xA00C61ad8c560163c3Ee798a5eAA63EF81BA41e0"),
    {
      name: "Re7 Labs sUSDX",
      description: "Component of the Re7 Labs BSC Cluster",
      entity: "re7-labs",
    },
  ],
  [
    getAddress("0x93d31b79502265FEBA5ED18e3cAc9ef795a3b0B1"),
    {
      name: "K3 Capital ASTERLIQUID ASTER",
      description: "Component of the K3 Capital ASTERLIQUID Market",
      entity: "k3-capital",
    },
  ],
  [
    getAddress("0x95C5Fd8618C68D6156A739C1EAb5aA7c807ff148"),
    {
      name: "K3 Capital ASTERLIQUID USDT",
      description: "Component of the K3 Capital ASTERLIQUID Market",
      entity: "k3-capital",
    },
  ],
])
